import { PaymentTypes } from './payment.model';
import { IntegrationSources, PaymentFormField } from './paymentMethod.model';

export enum ResultActionContainers {
  DIRECT = 'direct',
  DISPLAY = 'display',
  IFRAME = 'iframe',
  PARAMETERS = 'parameters',
  REDIRECT = 'redirect',
  WINDOW = 'window',
}

export enum ResultActionTypes {
  HTML = 'html',
  REDIRECT = 'redirect',
  FORM = 'form',
  DISPLAY = 'display',
}

export enum ResultActionMethods {
  POST = 'POST',
  GET = 'GET',
}

export interface ResultAction {
  type: ResultActionTypes;
  url: string | null;
  method: ResultActionMethods;
  parameters: { [key: string]: string };
  container: ResultActionContainers;
  height: number;
  width: number;
  output: string | null;
  fields: PaymentFormField[];
}

export interface RegisterPaymentPayload {
  referenceId: string;
  type: PaymentTypes;
  walletId: string;
  sessionId: string;
  merchantId: string;
  registration: {
    accountId?: string | null;
    methodId: string;
    attributes: { [key: string]: string };
  };
}

export interface PaymentActionResult {
  transactionId: string;
  status: string;
  resultAction: ResultAction | null;
  description: string | null;
  //TODO: think about moving this parameter to separated 'resultAction'
  paymentAttributes: PaymentFormField[];
}

export interface AttributeErrorBag {
  [key: string]: string[];
}

interface FieldData {
  path: string;
  message: string;
  value: string;
}

interface PaymentData {
  id: string;
  reasonCode: string;
}

interface UiData {
  display: 'banner' | 'field' | 'screen';
  message: string | null;
}

export interface PaymentActionErrorContext {
  ui: UiData;
  fields: FieldData[];
  payment: PaymentData;
}

export interface PaymentActionError {
  message: string;
  attributeErrorBag: AttributeErrorBag | null; //@TODO: will be unnecessary after PGW-3023 deploy to PROD
  errorDetails: { description: string; code?: string } | null;
  transactionId: string | null;
  context: PaymentActionErrorContext | null;
}

export interface ProcessPaymentPayload {
  paymentMethodId: string;
  vendor: string;
  merchantId: string;
  paymentType: PaymentTypes;
  userId: string;
  sessionId: string;
  paymentAttributes: { [key: string]: string };
  callbackParameterBag: { [key: string]: string };
  referenceId: string;
  source: IntegrationSources;
}
